module.exports = __webpack_public_path__ + "static/media/image_logo_feige_color.05393b3a.png";